/**
 * NIHARA LUXURY MAISON — JANMASHTAMI FESTIVAL ENGINE
 * 1. Header: Botanical Wildflower Strip with Zero-Gap Flush Lower Edge Alignment
 * 2. Right Header: Traditional Hanging Matki with Attached Centered Swaying Thread
 * Namespace: NiharaFestivalEngine / [data-nihara-festival-root]
 */
(function() {
  'use strict';

  function NiharaFestivalEngine() {
    this.rootEl = null;
    this.garlandEl = null;
    this.matkiEl = null;

    this.scrollHandlerBound = null;
    this.resizeHandlerBound = null;
    this.isInitialized = false;
  }

  NiharaFestivalEngine.prototype.init = function() {
    this.rootEl = document.querySelector('[data-nihara-festival-root]');
    if (!this.rootEl) return;

    var isEnabled = this.rootEl.getAttribute('data-enable-festival') === 'true';
    if (!isEnabled) {
      this.destroy();
      return;
    }

    this.destroy();
    this.rootEl = document.querySelector('[data-nihara-festival-root]');
    if (!this.rootEl) return;

    this.garlandEl = this.rootEl.querySelector('[data-nihara-garland]');
    this.matkiEl = this.rootEl.querySelector('[data-nihara-matki]');

    // Setup Header Scroll Reveal with Zero-Gap Alignment
    this.checkHeaderScrollReveal();

    // Attach Observers
    this.attachObservers();

    this.isInitialized = true;
  };

  NiharaFestivalEngine.prototype.checkHeaderScrollReveal = function() {
    if (!this.rootEl) return;

    var scrollY = window.scrollY || window.pageYOffset || 0;
    var threshold = parseInt(this.rootEl.getAttribute('data-reveal-threshold'), 10) || 15;
    var vOffset = parseInt(this.rootEl.getAttribute('data-vertical-offset'), 10);
    if (isNaN(vOffset)) vOffset = -8;

    var headerEl = document.querySelector('.mobile-header-section, .mobile-header, .site-header, header');
    var headerBottom = 58;
    if (headerEl) {
      var rect = headerEl.getBoundingClientRect();
      headerBottom = Math.max(0, rect.bottom);
    }

    // Exact Zero-Gap alignment to lower edge of header (minus 1px for seamless overlap with bottom border)
    var targetTop = Math.max(0, Math.floor(headerBottom - 1) + vOffset);
    var isRevealed = scrollY > threshold;

    if (this.garlandEl) {
      this.garlandEl.style.top = targetTop + 'px';
      if (isRevealed) {
        this.garlandEl.classList.add('is-revealed');
      } else {
        this.garlandEl.classList.remove('is-revealed');
      }
    }

    if (this.matkiEl) {
      this.matkiEl.style.top = targetTop + 'px';
      if (isRevealed) {
        this.matkiEl.classList.add('is-revealed');
      } else {
        this.matkiEl.classList.remove('is-revealed');
      }
    }
  };

  NiharaFestivalEngine.prototype.attachObservers = function() {
    var self = this;

    this.scrollHandlerBound = function() {
      self.checkHeaderScrollReveal();
    };
    window.addEventListener('scroll', this.scrollHandlerBound, { passive: true });

    this.resizeHandlerBound = function() {
      self.checkHeaderScrollReveal();
    };
    window.addEventListener('resize', this.resizeHandlerBound, { passive: true });
  };

  NiharaFestivalEngine.prototype.destroy = function() {
    if (this.scrollHandlerBound) {
      window.removeEventListener('scroll', this.scrollHandlerBound);
    }
    if (this.resizeHandlerBound) {
      window.removeEventListener('resize', this.resizeHandlerBound);
    }
    this.isInitialized = false;
  };

  function initEngine() {
    if (window.niharaFestivalInstance) {
      window.niharaFestivalInstance.destroy();
    }
    window.niharaFestivalInstance = new NiharaFestivalEngine();
    window.niharaFestivalInstance.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEngine);
  } else {
    initEngine();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.classList.contains('nihara-festival-section')) {
      initEngine();
    }
  });
  document.addEventListener('shopify:section:unload', function(e) {
    if (e.target && e.target.classList.contains('nihara-festival-section')) {
      if (window.niharaFestivalInstance) {
        window.niharaFestivalInstance.destroy();
      }
    }
  });

})();
